module.exports = __webpack_public_path__ + "media/images/sushi-16bba185b4112d0eb7674f6e86642d04.png";